import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CountryType } from '../../core/constants/shop-management.config';
import { AddressDirectoryControllerService } from '@soctrip/angular-shipment-service';
import { CustomTranslateService } from '../../core/services/custom-translate.service';
import { ViewportScroller } from '@angular/common';
import { RegionCode } from '../shop-management/constants/Metrics-overview';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-rss-config',
  templateUrl: './rss-config.component.html',
  styleUrls: ['./rss-config.component.scss']
})
export class RssConfigComponent implements OnInit {
  safeUrl: SafeResourceUrl;
  isLoading: boolean = true;
  lang: string = 'vi';

  selectedRegion: CountryType;
  regions: [] = [];
  loadingRegion: boolean = false;

  constructor(
    private addressDirectoryService: AddressDirectoryControllerService,
    private sanitizer: DomSanitizer,
    private customTranslateService: CustomTranslateService,
    private viewportScroller: ViewportScroller,
  ) {}

  ngOnInit(): void {
    this.viewportScroller.scrollToPosition([0, 0]);
    this.lang = this.customTranslateService.getCurrentLanguage();
    this.updateIframeSource();
    this._InitRegionAndShopsAdminManagement();

    this.customTranslateService.language$.subscribe((lang) => {
      if(typeof lang !== 'string') return;
      this.lang = lang;
      this.isLoading = true;
      this.updateIframeSource();
    });
  }

  updateIframeSource(): void {
    console.log(this.lang);
    this.isLoading = true;
    const RSSSource = `${environment.FLIGHT_ADMIN_URL}/admin/rss/SHOP?lang=${
      this.lang
    }`;
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      RSSSource,
    );
  }

  onIframeLoad(): void {
    this.isLoading = false;
  }

  _InitRegionAndShopsAdminManagement() {
    this.loadingRegion = true;
    this.addressDirectoryService.addressCountriesGet().subscribe({
      next: (res: any) => {
        this.regions = res?.data;
        this.selectedRegion = res?.data.find(
          (el: CountryType) => el?.code_name == RegionCode.VN,
        );
      },
    });
  }

  onChangeRegion() {
    this.updateIframeSource();
  }
}
